import { getCountriesCall, getGlobalCountriesCall } from "../services/mightyWifiApi";
import { SET_COUNTRY, SET_COUNTRIES } from "./types";

export function setCountry(country) {
  return {
    type: SET_COUNTRY,
    country
  };
}

export function setCountries(countries) {
  return {
    type: SET_COUNTRIES,
    countries
  };
}

export const getCountries = () => {
  return dispatch => {
    return getCountriesCall().then(res => {
      if (res.status) {
        console.log(res);
        dispatch(setCountries(res.data));
      }
    });
  };
}

export const getGlobalCountries = () => {
  return dispatch => {
    return getGlobalCountriesCall().then(res => {
      if (res.status) {
        console.log(res);
        dispatch(setCountries(res.data));
      }
    });
  };
};


// WEBPACK FOOTER //
// ./src/modules/actions/countryActions.js